export enum FormFactor {
  Mobile = 0,
  Tablet = 1,
  Laptop = 2,
  Desktop = 3,
}
